import { Component, inject, input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

/** The `product-sorting` partial: a select that reloads the page with a new `sort` parameter. */
@Component({
  selector: 'product-sorting',
  host: {
    style: 'display: contents'
  },
  template: `
    <div class="flex-w" id="product-sorting">
      @if (many()) {
        <div class="bo4 of-hidden w-size12 m-t-5 m-b-5 m-r-10">
          <select class="select-native select-native-lg" name="sorting" (change)="sortBy($any($event.target).value)">
            <option value="popularity,desc" [selected]="sort() === 'popularity,desc'">за популярністю</option>
            <option value="id,desc" [selected]="sort() === 'id,desc'">за новизною</option>
            <option value="price,asc" [selected]="sort() === 'price,asc'">ціна: від дешевих</option>
            <option value="price,desc" [selected]="sort() === 'price,desc'">ціна: від дорогих</option>
          </select>
        </div>
      }
    </div>
    `
})
export class ProductSortingComponent {

  readonly sort = input<string>();
  /** The select is hidden for a single product, as the Mustache `page.getContent.1` check did. */
  readonly many = input(false);

  private route = inject(ActivatedRoute);
  private router = inject(Router);

  sortBy(sort: string) {
    return this.router.navigate([], {
      relativeTo: this.route,
      // Back to the first page, where the new order starts
      queryParams: { sort, page: null },
      queryParamsHandling: 'merge'
    });
  }

}
